<template>
  <div class="CarNetwork">
    <div class="CarNetwork-header">
      <el-container>
      <el-header >
        <v-head
  :active="1"
          :bannerData="bannerData"
          :isBanner="true"
          :color="'black'"
          indicator="none"
          
        ></v-head>
        <szhimg
          :bannerData="bannerData"
          :isBanner="true"
          :color="'black'"
          indicator="none"
        />
        <plan-dialog
            :isShow="isShow"
            v-if="isShow"
            @closeTop="closeTop"
          ></plan-dialog>
      </el-header>
    </el-container>
    </div>

    
        
      <div class="car-network-section">
        <img src="../../../public/img/internet/chelianwang.png" alt="" />
      </div>
      <div class="car-network-sections">
        <img src="../../../public/img/internet/pingtaijieshao.png" alt="" />
      </div>
      <div class="platform-advantages">
        <h2 class="section-title">平台优势</h2>
        <div class="advantages-container">
          <div class="advantage-item">
            <div class="icon-wrapper">
              <!-- Icon placeholder -->
              <img src="../../../public/img/internet/Frame1.png" alt="" />
            </div>
            <div class="icon-wrapperss">
              <h3>一站式出海服务</h3>
            <p>
              为客户提供标准化服务，一站式对接海外运营商，助力车企快速出海，推向市场
            </p>
            </div>
          </div>
          <div class="advantage-item">
            <div class="icon-wrapper">
              <!-- Icon placeholder -->
              <img src="../../../public/img/internet/Frame2.png" alt="" />
            </div>
            <div class="icon-wrapperss">
              <h3>全球资源覆盖</h3>
            <p>
              聚合海内外优质运营商，网联资源覆盖全球180+国家/地区，为客户提供一体化解决方案
            </p>
            </div>
          </div>
          <div class="advantage-item">
            <div class="icon-wrapper">
              <!-- Icon placeholder -->
              <img src="../../../public/img/internet/Frame3.png" alt="" />
            </div>
            <div class="icon-wrapperss">
              <h3>精细化运营</h3>
            <p>
              依托云百自由平台，自定义套餐功能和价值，精细化业务用量统计，帮助客户提高综合运营效益
              </p>
            </div>
          </div>
          <div class="advantage-item">
            <div class="icon-wrapper">
              <!-- Icon placeholder -->
              <img src="../../../public/img/internet/Frame4.png" alt="" />
            </div>
            <div class="icon-wrapperss">
              <h3>全球支付</h3>
            <p>
              支持全球140+国家/地区收款（含国际卡收款、Apple pay、Google pay等国际流行支付方式）
            </p>
            </div>
          </div>
        </div>
      </div>
      <div class="bigimg">
        <img src="../../../public/img/internet/Frame5.png" alt="" />
      </div>
      <div class="foter">
        <v-footer></v-footer>
      </div>
  </div>
</template>

<script>
import vHead from "@/components/head.vue";
import szhimg from "../chelianwang.vue";
import planDialog from "@components/planDialog.vue";
import vFooter from "@/components/footer2.vue";
export default {
  name: "CarNetwork",
  components: {
    vHead,
    szhimg,
    planDialog,
    vFooter,
  },
  data() {
    return {
      isShow: false,
      bannerData: [
        {
          title: "车联网",
          content:
            "云百对全球运营商资源进行全方面的调研和评估，与海外各国大型运营商保持长期深入的合作关系，应用eSIM、VSIM解决方案，为车企提供稳定的全球网络连接和优质的服务质量，同时提供海外数据安全法规等合规建议，避免产品出海产生的政策风险和经济损失，助力车企扩大海外战略布局。",
          button: "获取专属方案",
          banner: "digital_bg1",
        },
      ],
    };
  },
  methods: {
    closeTop() {
      this.isShow = false;
    },
  },
  mounted(){
    
  }
};
</script>

<style lang="scss" scoped>
.fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.el-header {
  height: 80px !important;
  padding: 0;
  position: relative;
}

.car-network-section {
  margin-top: 70px;
  img {
    width: 100%;
    height: 415px;
    object-fit: cover;

  }
}
.car-network-sections {
  // margin-top: 20px;
  img {
    width: 100%;
    height: 869px;
    // object-fit: cover;
  }
}
.car-network-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  gap: 60px;
  padding: 0 20px;
}

.map-side {
  flex: 1;
  position: relative;
}

.map-image {
  width: 100%;
  height: auto;
  display: block;
}

.text-side {
  flex: 1;
  padding-top: 20px;
}

.title {
  font-size: 36px;
  font-weight: bold;
  color: #333;
  margin: 0 0 30px 0;
}

.description {
  font-size: 16px;
  line-height: 1.8;
  color: #666;
  margin: 0;
}

.platform-advantages {

  padding: 60px 0;
  max-width: 1400px;
  margin: 0 auto;  

  .section-title {
    text-align: center;
    font-size: 40px;
    font-weight: 600;
    margin-bottom: 60px;
    color: #333;
    position: relative;
    font-family: PingFang SC, PingFang SC-500;  
    
    &::after {
      content: '';
      position: absolute;
      bottom: -15px;
      left: 50%;
      transform: translateX(-50%);
      width: 80px;  /* 两个汉字的大约宽度 */
      height: 4px;  /* 下划线粗细 */
      background: linear-gradient(to right, #0C9AFF, #0C45FF);
      // border-radius: 2px;
    }
  }

  .advantages-container {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 30px;
    padding: 0 20px;
  }

  .advantage-item {
    padding: 30px 20px;
    border-radius: 8px;
    transition: all 0.3s ease;
    cursor: pointer;
    text-align: center;
    border: 1px solid #E5E7EB;
    height: 240px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    &:hover {
    border-color: #4080ff;

      // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    .icon-wrapper {
      width: 60px;
      height: 60px;
      margin: 0 auto 20px;
      // background: #f5f7fa;
      border-radius: 8px;
      img{
        margin-right: 10px;
      }
    }

    h3 {
      font-size: 20px;
      font-weight: 600;
      color: #333;
      margin-bottom: 16px;
    }

    p {
      font-size: 14px;
      line-height: 1.6;
      color: #666;
      margin: 0;
    }
  }
}

@media (max-width: 1024px) {
  .car-network-content {
    flex-direction: column;
    gap: 30px;
  }

  .text-side {
    padding-top: 0;
  }

  .platform-advantages {
    .advantages-container {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}

@media (max-width: 640px) {
  .platform-advantages {
    padding: 40px 0;

    .advantages-container {
      grid-template-columns: 1fr;
    }

    .section-title {
      font-size: 24px;
      margin-bottom: 40px;
      font-family: PingFang SC, PingFang SC-500;
    }
  }
}
.icon-wrapper {

  img {
    width: 92px;
    height: 92px;
    margin-left:-15px ;
  }
}
.bigimg {
  margin-top: 60px;
  img {
    width: 100%;
    height: 1055px;
    object-fit: cover;

  }
}
.foter {
  margin-top: 60px;
}
.CarNetwork-header{
  height: 640px;
}
.icon-wrapper{
  text-align: center;
}
.icon-wrapperss{
  h3{
    padding-top: 30px;
    height: 15px;
  }
  p{
    padding-top: 0px;
    font-weight: 200;
    width: 244px;
    margin: 0 auto;
    padding-left: 17px;
    text-align: left;
  }
}
</style>
